<template>
    <div id="kt_header" class="header app-header">
        <div class="app-container d-flex align-items-stretch justify-content-between container-fluid">
            <div id="kt_app_header_wrapper" class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
                <div class="app-header-menu app-header-mobile-drawer align-items-stretch">
                </div>
                <div class="app-navbar flex-shrink-0">
                    <div class="d-flex align-items-center ms-1 ms-lg-3" >
                    </div>
                    <div v-if="isLoggedIn" class="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle" >
                            <BDropdown menu-class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-375px" variant="link" size="sm" no-caret>
                                <template #button-content>
                                    <div class="cursor-pointer symbol symbol-circle symbol-30px symbol-md-40px">
                                        <img v-bind:src="user.image_url" alt="user">
                                    </div>
                                </template>
                                <BDropdownText>
                                    <div class="menu-item px-3">
                                        <div class="menu-content d-flex align-items-center px-3">
                                            <div class="symbol symbol-50px me-5">
                                                <img alt="Avatar" v-bind:src="user.image_url" />
                                            </div>
                                            <div class="d-flex flex-column">
                                                <div class="fw-bold text-dark d-flex align-items-center fs-5">{{user.full_name}}</div>
                                                <span class="fw-semibold text-muted fs-7">{{user.email}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </BDropdownText>
                                <BDropdownDivider>My Profile</BDropdownDivider>
                                <b-dropdown-item :to="{name: 'my.Account'}" class="menu-item px-5" link-class="menu-link px-5">My Profile</b-dropdown-item>
                                <b-dropdown-divider v-if="isAdmin">Administration</b-dropdown-divider>
                                <b-dropdown-item v-if="isAdmin" :to="{name: 'admin.Dashboard'}" class="menu-item px-5" link-class="menu-link px-5">Administration</b-dropdown-item>
                                <b-dropdown-item-button @click="logout" class="menu-item px-5" button-class="menu-link px-5">Logout</b-dropdown-item-button>
                            </BDropdown>

                        </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import axios from "axios";
import {BDropdown, BDropdownDivider, BDropdownItem, BDropdownItemButton, BDropdownText } from 'bootstrap-vue-next';


export default {
    name: 'DHeader',
    components: {
        BDropdown, BDropdownDivider, BDropdownItem, BDropdownItemButton, BDropdownText

    },
    computed : {
        isLoggedIn : function(){ return this.$store.getters['auth/isAuthenticated'] },
        isAdmin : function(){ return this.$store.getters['auth/isAdmin'] },
        user : function(){ return this.$store.getters['auth/getFullUser'] },
    },
    data () {
        return {
            show_sidebar: false,
        }
    },
    created(){

    },
    methods: {

        async logout (){

            this.$store.dispatch('auth/logout').then(response => {
                this.$store.dispatch('auth/getUser').then(response => {

                    location.reload();
                    //this.$router.push({name: 'auth.SignIn'});
                });
            });

        },

        toogleMenuMobile() {
            if( this.show_sidebar ) {
                this.show_sidebar = false;
            } else {
                this.show_sidebar = true;
            }
            this.$emit("childToParent", this.show_sidebar);
        },


        toogleMenuNotices() {
            this.showMenuNotices = this.showMenuNotices ? false : true;
        },



        setTheme(theme) {
            const html = document.querySelector("html");
            html.setAttribute("data-theme", theme);

            let uri = '/api/settings/settheme';
            let data = {
                theme: theme
            };
            axios.post(uri, data).then((response) => {


            });

        }

    }
}
</script>
<style>
#hPNotices {
    position: relative;
}
#hPNotices .menu.show {
    position: absolute;
    top: 50px;
    right: 0;
}

#kt_header_user_menu_toggle:hover {

}
#kt_header_user_menu_toggle:hover div[data-kt-menu=true] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
    z-index: 107;
    position: fixed;
    inset: 0px 0px auto auto;
    margin: 0;
    transform: translate3d(-30px, 50px, 0px);
}

.boxheader {
    padding-left: 1.5rem !important;
    padding-right: 30px !important;
}


</style>
